import { render, staticRenderFns } from "./SecurityTips.vue?vue&type=template&id=5f2f20e4"
import script from "./SecurityTips.vue?vue&type=script&lang=js"
export * from "./SecurityTips.vue?vue&type=script&lang=js"
import style0 from "./SecurityTips.vue?vue&type=style&index=0&id=5f2f20e4&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports